.container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 125px;
  gap: 8px;
}

.iconSuccess {
  color: var(--tuna-palette-success-main);
}

.iconDisabled {
  color: var(--tuna-palette-action-disabled);
}

.unvoteText {
  color: var(--tuna-palette-action-disabled);
}
